import {Box, Dialog, IconButton} from "@mui/material";
import {Fragment} from "react";
import {ArrowBack, ArrowForward, Close} from "@mui/icons-material";
import {useSwipeable} from "react-swipeable";

interface Props {
    imageList: string[];
    handleClose: () => void;
    handlePrev: () => void;
    handleNext: () => void;
    currentImageIndex: number;
}

const ImageCarousel = ({
                           imageList,
                           handleClose,
                           handlePrev,
                           handleNext,
                           currentImageIndex,
                       }: Props) => {
    const swipeHandlers = useSwipeable({
        onSwipedLeft: handleNext,
        onSwipedRight: handlePrev,
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    return (
        <Dialog open={imageList.length > 0} onClose={handleClose} maxWidth="xl">
            {imageList.length > 0 && (
                <Fragment>
                    <Box
                        {...swipeHandlers}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            padding: 2,
                            touchAction: "pan-y",
                        }}
                    >
                        <IconButton
                            onClick={handleClose}
                            sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                color: "white",
                                zIndex: 10,
                            }}
                        >
                            <Close/>
                        </IconButton>

                        <IconButton
                            onClick={handlePrev}
                            sx={{
                                position: "absolute",
                                left: 16,
                                color: "white",
                            }}
                        >
                            <ArrowBack/>
                        </IconButton>

                        <Box
                            component="img"
                            src={imageList[currentImageIndex]}
                            alt="Full-size review"
                            sx={{
                                maxHeight: "80vh",
                                maxWidth: "100%",
                                objectFit: "contain",
                            }}
                        />

                        <IconButton
                            onClick={handleNext}
                            sx={{
                                position: "absolute",
                                right: 16,
                                color: "white",
                            }}
                        >
                            <ArrowForward/>
                        </IconButton>
                    </Box>
                </Fragment>
            )}
        </Dialog>
    );
};

export default ImageCarousel;